<template>
  <div class="content">
    <loading v-if="loading" text='Loading. Please wait...'/>
    <div v-show="!loading">
      <h1 v-if="group" class="no-right-tools">{{group.name}}</h1>
      <span v-show="error" class="help is-danger">{{error}}</span>

      <AppWideSearch 
        searchPlaceholder="Search in group" 
        :currentGroupCode="$route.params.id" 
        @appWideSearchActive="onAppWideSearchActive"
      />
      <slot v-if="!appWideSearchEnable">
      <div class="header-bar"> 
        <h2>Books</h2>
      </div>

        <Books
          v-bind="{
            bookList: booksForGroup,
            listView: false
          }"
        />

        <div v-if="group._id" class="lps header-bar"> 
          <h2 style="margin-bottom: 0;">
            {{ lpSingularName }}
          </h2>
          <div class='right-tools no-select'>
            <router-link :to="'/lp/' + group._id" style="margin-top: 10px; display: inline-block;">Open</router-link>
          </div>
        </div>
      </slot>
    </div>    
    <learning-path v-if="!loading && group._id" v-show="!appWideSearchEnable" class="lp-scroll"></learning-path>
  </div>
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');

  require('./itsi-lp-bridge.js');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import bookUtils from '@/utils/bookUtils.js';
  import storeHelpers from '@/utils/storeHelpers.js';
  import AppWideSearch from './AppWideSearch'
  import Books from '@/components/library/Books'
  
  export default {
    name: 'GroupDashboard',
    components: {
      AppWideSearch,
      Books
    },
    data: function () {
      var t = this;

      return {
       loading: true,
       group: {},
       lpData: {},
       moment: moment,
       utils: utils,
       bookUtils: bookUtils,
       error: '',
       lpSingularName: '',
       booksForGroup: [],
       unwatchFunctions: [],
       appWideSearchEnable: false
      }
    },
    destroyed: function() {
      _.each(this.unwatchFunctions, function(unwatchFunction) {
        unwatchFunction();
      });
    },
    mounted: function () {
      this.lpSingularName = utils.getNavName('5b450d6f-2205-48eb-b4a2-5ee1f1be36b9', this, false, 'Learning Paths')
      this.unwatchFunctions = utils.watchStorePropertiesWithCallback(this, ['bookList','groups', 'resources', 'attachments', 'learningPaths', 'userState'], this.lpUpdated);
      this.itsiLPBridge();
    },
    methods: {
      lpUpdated: function (property, value) {
        var t = this;

        var group = _.find(t.$store.state.groups, function(group) {
          return group.code === t.$route.params.id;
        })

        if(!group) return;

        // update book resource count
        t.booksForGroup = storeHelpers.getBooks(this, group.code);
        const resourcesPerBook = storeHelpers.getResourcesPerBookNoAnnotations(this);

        _.each(this.booksForGroup, function(book) {
          const unread = _.filter(resourcesPerBook[book.id], function(resourceWithAtt) {
            return resourceWithAtt.isUnread && !resourceWithAtt.resource.private;
          });
          
          Vue.set(book, 'unreadResources', unread.length);
        });

        t.loading = false;

        t.group = group;
        if (t.group._id) {
          t.lpData = storeHelpers.getLPData(this, group._id);

          const pagesOpened = storeHelpers.getPagesOpened(this, group.code);

          setTimeout(function() {
            t.loading = false;

            window.lp.renderPath(t.lpData.lpItems, t.lpData.resources, t.lpData.attachments, t.lpData.userState, t.lpData.tags, pagesOpened, 'web', false, '')   
            window.lp.resizeLPItems();
          }, 500)
        }
      },
      onAppWideSearchActive: function(val) {
        this.appWideSearchEnable = val.length > 0 ? true : false;
      },
      itsiLPBridge: function() {
        var t = this;
        window.ITSIBridge = {
          disableScroll: true,
          lpTopVisibleElementChanged: function (lpItemId) {
            utils.log(t, 'Top visible changed ' + lpItemId);
          },
          resourceLPItemClicked: function (lpItemId, attachmentId, resourceId, isTask) {
            utils.log(t, 'LP Item clicked: ' + lpItemId + ' attachmentId: ' + attachmentId + ' resourceId: ' + resourceId);
            utils.openResourceById(t, resourceId, [attachmentId])
          },
          lpPageRangeClicked: function(lpItemId, book, pageFrom, pageTo) {   
            utils.log(t, 'lpPageRangeClicked: ' + lpItemId + ' book: ' + book + ' pageFrom: ' + pageFrom + ' pageTo: ' + pageTo);
            t.$router.push("/book/" + book + "/" + pageFrom);
          },
          lpItemToggle: function (lpItemId, expanded) {
            utils.log(t, 'LP Item toggled: ' + lpItemId + ', expanded: ' + expanded);
          },
          lpSearchFinished: function (currentSearchIndex, numberOfResults) {
            utils.log(t, 'LP search results for ' + window.platform + ': ' + currentSearchIndex + ' of ' +numberOfResults);

            t.lpCurrentSearchCount = numberOfResults;
            t.lpCurrentSearchIndex = currentSearchIndex;
          },
          lpSearchCleared: function () {
            t.lpCurrentSearchCount = 0;
            t.lpCurrentSearchIndex = 0;
          },
          navToLPItem: function (lpItemId, isVisible) {
            utils.log(t, 'LP nav from TOC: ' + lpItemId + ' (visible: ' + isVisible + ')');
          },
          resetLPFilters: function () {
            utils.log(t, 'Reset all LP filters');
            t.resetAllFilters();
          },
          lpTagClicked: function (tag, active) {
            utils.log(t, 'LP tag: ' + tag + ' (active: ' + active + ')');
          },
          gotoLocation: function (attachment) {
            utils.log(t, 'Go to location: Attachment: ' + attachment._id + ' book: ' + attachment.book + ' section: ' + attachment.section + ' selector: ' + attachment.selector);
          },
          parseJSONifString: function (possibleString) {
            return possibleString;
          },
          pageLoaded: function () {
          },
          smileyMagic: function (string) {
            // same across platforms
            return decodeURIComponent(escape(string));
          }
        };
      }
    }
  }
</script>

<style>
.learning-path {
  position: relative;
  overflow-x: hidden;
}

.learning-path .loading {
    display: none;
}

.learning-path .sidenav {
  position: absolute;
  text-align: left;
  z-index: 0;
}

.learning-path .sidenav .title {
  font-size: 12pt;
}

.learning-path .sidenav ul ul {
  margin-top: 0;
}
</style>

<style scoped lang="scss">
@import "src/css/vars.scss";

.lp-scroll {
  height: 300px;
  overflow-y: auto;
}
.lp-toc-button {
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
}

.lp-toc-button .fal {
  font-size: 14pt;
}

.search {
  margin-bottom: 0;
}

.learning-path {
  margin-top: -10px;
}

.group {
  text-align: left;
  border-bottom: 1px solid $background-color-dark;
  height: 70px;
}

.group:hover {
  background: $background-color-dark;
  cursor: pointer;
}

.group span {
  margin-left: 10px;
  display: inline-block;
  vertical-align: top;
  margin-top: 22px;
}

.group-color {
  width: 10px;
  height: 100%;
  background: black;
  display: inline-block;
}

.content {
  padding-bottom: 30px;
}
</style>